import { createSlice } from '@reduxjs/toolkit';

export const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    mode: localStorage.getItem('mode') || 'dark',
  },
  reducers: {
    changeModeAction: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { changeModeAction } = themeSlice.actions;
export const themeSelector = (state) => state.theme;
export default themeSlice.reducer;
